<template>
  <div
    class="w-full border-b border-secondary-light leading-normal relative"
    :class="{
      'rounded-lg': !flat,
      'border': flat
    }"
  >
    <div
      class="w-full heading-md flex p-2 select-none justify-between"
      :class="{
        'px-4': background,
        'cursor-pointer': !disabled,
        'pointer-events-none': disabled
      }"
      @click="toggle()"
    >
      <div class="flex gap-2 items-center justify-start">
        <div class="border-secondary-lightest">
          <iconAngleDown v-show="!open" class="w-5 h-5 fill-current" />
          <iconAngleUp v-show="open" class="w-5 h-5 fill-current" />
        </div>

        <slot name="logo" v-if="showGdLogo">
          <img :src="brandData.brandLogo" class="w-5 h-5 pr-2" />
        </slot>

        <span>{{ title }}</span>
      </div>

      <button
        v-if="tooltip"
        v-tooltip.left-start="{
          content: tooltip,
          classes: [
            'bg-black',
            'text-white',
            'p-1',
            'rounded',
            'max-w-xxs',
            'mt-6'
          ]
        }"
        class="mr-4 italic focus:outline-none"
      >
        <info-icon class="fill-current w-4 h-4" />
      </button>
    </div>

    <div v-if="open" class="w-full px-3 py-2">
      <slot><span class="text-secondary-invert">Default Content</span></slot>
    </div>
  </div>
</template>

<script>
import { VTooltip } from 'v-tooltip';
import iconAngleDown from '../assets/icon-angle-down.svg';
import iconAngleUp from '../assets/icon-angle-up.svg';
import InfoIcon from '../assets/icons/info.svg';

export default {
  name: 'ExpansionPanel',
  components: {
    iconAngleDown,
    iconAngleUp,
    InfoIcon
  },
  directives: { tooltip: VTooltip },
  props: {
    title: {},
    background: {default: false},
    flat: { default: false },
    showGdLogo: { default: false },
    openOnLoad: { default: false },
    tooltip: {},
    disabled: { default: false }
  },
  data() {
    return { open: false };
  },
  mounted() {
    if (this.openOnLoad) {
      this.toggle();
    }
  },
  computed: {
    brandData() {
      return this.$store.getters.brandData;
    }
  },
  methods: {
    close() {
      this.open = false;
    },
    toggle() {
      this.open = !this.open;
      this.$nextTick(() => {
        this.$emit(this.open ? 'open' : 'close');
      });
      if (this.open && this.$parent.closeOtherPanels) {
        this.$parent.closeOtherPanels(this._uid);
      } else if (
        this.open &&
        this.$parent &&
        this.$parent.$parent &&
        this.$parent.$parent.closeOtherPanels
      ) {
        this.$parent.$parent.closeOtherPanels(this._uid);
      }
    }
  }
};
</script>
